
import Announcements from "../employee-engagement/Announcements";

export { Page }

function Page() {
  return <Announcements />;
}
